import React from 'react';
import { Star } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function Testimonios() {
  const revealRef = useScrollReveal();
  const renderStars = () => <div className="px-4 pt-3.5 pb-1.5 text-oro flex gap-1" data-id="element-364">
      <Star size={13} className="fill-current" data-id="element-365" />
      <Star size={13} className="fill-current" data-id="element-366" />
      <Star size={13} className="fill-current" data-id="element-367" />
      <Star size={13} className="fill-current" data-id="element-368" />
      <Star size={13} className="fill-current" data-id="element-369" />
    </div>;
  return <section id="testimonios" className="bg-negro py-14 sm:py-[90px] px-6" data-id="element-370">
      <div ref={revealRef} className="max-w-[1060px] mx-auto reveal" data-id="element-371">
        <div className="text-center" data-id="element-372">
          <span className="text-[11px] tracking-[5px] uppercase text-oro mb-4 block" data-id="element-373">
            Prueba social real
          </span>
          <h2 className="font-playfair text-[clamp(28px,4.5vw,52px)] font-bold leading-[1.15] mb-6" data-id="element-374">
            Lo que dicen quienes ya
            <br data-id="element-375" />
            usan El Método Italiano™
          </h2>
          <div className="w-[60px] h-[2px] bg-gradient-to-r from-oro to-transparent mx-auto my-5" data-id="element-376"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14" data-id="element-377">
          <div className="bg-gris-oscuro rounded-md overflow-hidden border border-white/5" data-id="element-378">
            <img src="https://i.postimg.cc/j5khGHm8/download-1-min.png" alt="Testimonio 1" className="w-full block" data-id="element-379" />
            {renderStars()}
          </div>
          <div className="bg-gris-oscuro rounded-md overflow-hidden border border-white/5" data-id="element-380">
            <img src="https://i.postimg.cc/nzw164g3/download-2-min.png" alt="Testimonio 2" className="w-full block" data-id="element-381" />
            {renderStars()}
          </div>
          <div className="bg-gris-oscuro rounded-md overflow-hidden border border-white/5" data-id="element-382">
            <img src="https://i.postimg.cc/gJBKfVQN/download-min.png" alt="Testimonio 3" className="w-full block" data-id="element-383" />
            {renderStars()}
          </div>
        </div>
      </div>
    </section>;
}